import DataCortex from 'browser-data-cortex';

export default {
  log: DataCortex.log,
  preInit,
  init,
  addUserTag: DataCortex.addUserTag,
};

let g_preInitDone = false;
function preInit(done) {
  if (!g_preInitDone) {
    g_preInitDone = true;
    const opts = {
      api_key: process.env.DC_API_KEY,
      org_name: process.env.DC_ORG_NAME,
      app_ver: process.env.VERSION,
      add_error_handler: true,
    };
    DataCortex.init(opts);
  }
  done && done();
}
function init(done) {
  done && done();
}
